var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 132C103.346 132 132 103.349 132 68.0077C132 32.6664 103.346 4 68 4C32.6544 4 4 32.6509 4 68.0077C4 103.365 32.6544 132 68 132Z",
    fill: "#920079",
    stroke: "#68C0BB",
    strokeWidth: 6.59,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2452 85.7558H54.3264C51.9569 85.7558 49.8972 84.1451 49.3396 81.8376L41.6116 50.4455L32.8305 46.3414C30.2597 45.1334 29.1446 42.0825 30.3526 39.5116C31.5606 36.9408 34.6115 35.8257 37.1823 37.0337L48.1936 42.1754C49.6029 42.8414 50.6405 44.0958 51.0122 45.598L58.3685 75.4724H89.5129L95.7077 56.0363C96.5749 53.326 99.471 51.8393 102.166 52.7066C104.876 53.5738 106.363 56.4699 105.495 59.1646L98.1546 82.1783C97.4732 84.3155 95.4909 85.7558 93.2607 85.7558H93.2452Z",
    fill: "#68C0BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3493 93.7471C90.3493 96.891 87.794 99.4464 84.6501 99.4464C81.5062 99.4464 78.9664 96.891 78.9664 93.7471C78.9664 90.6033 81.5217 88.0634 84.6501 88.0634C87.7785 88.0634 90.3493 90.6188 90.3493 93.7471Z",
    fill: "#68C0BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6962 93.7471C70.6962 96.891 68.1409 99.4464 64.997 99.4464C61.8531 99.4464 59.2978 96.891 59.2978 93.7471C59.2978 90.6033 61.8531 88.0634 64.997 88.0634C68.1409 88.0634 70.6962 90.6188 70.6962 93.7471Z",
    fill: "#68C0BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassStore);
export default __webpack_public_path__ + "static/media/classStore.5fcc0eaecaf0ba0dacb9415b16dedecc.svg";
export { ForwardRef as ReactComponent };